import MindNavbar from "../components/mind/mindNavbar"

const Mind=({setc})=>{

    setc("#15171C")
    return <div>
       <MindNavbar></MindNavbar>
    </div>
}

export default Mind